<alg-left-header *ngIf="showLeftMenuOpener" [compactMode]="true"></alg-left-header>
<alg-content-top-bar
  [showBreadcrumbs]="showBreadcrumbs"
  [showLeftMenuOpener]="showLeftMenuOpener"
></alg-content-top-bar>
<alg-top-right-controls *ngIf="showTopRightControls" [drawLeftBorder]="!modeBarDisplayed"></alg-top-right-controls>
